export default __webpack_public_path__ + "static/media/logo.a1a875f8.svg";